// extracted by mini-css-extract-plugin
module.exports = {"bottomButton":"SolutionSection_bottomButton__OOWbp","title":"SolutionSection_title__1BxRB","button":"SolutionSection_button__Mi9R5"};